import {
  Button,
  FoundationColorTokens,
  Spacing,
  TableReloadHandle,
  Typography,
} from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";
import { Plus } from "lucide-react";
import React, { useState } from "react";
import { AddSPoCDialog } from "./userAccess/AddSPoCDialog";
import { Instance } from "mobx-state-tree";
import { ProjectDetailsStore } from "../store/ProjectDetailsStore";
import { NavigateToFunctions } from "../../../routes/RoutesHelper";
import { observer } from "mobx-react";

interface AddSPoCProps {
  t: TFunction;
  spacing: Spacing;
  projectDetailsStore: Instance<typeof ProjectDetailsStore>;
  navigateTo: NavigateToFunctions;
  tokens: FoundationColorTokens<string>;
  typography: Typography;
  userAccessTableRef: React.MutableRefObject<TableReloadHandle | null>;
}

export const AddSPoC = observer(
  ({
    t,
    navigateTo,
    spacing,
    projectDetailsStore,
    tokens,
    typography,
    userAccessTableRef,
  }: AddSPoCProps): React.ReactElement => {
    const [isAddSPoCDialogOpen, setIsAddSPoCDialogOpen] = useState(false);
    return (
      <>
        <Button
          icon={<Plus />}
          iconPosition="leading"
          label={t("projects.userAccess.addSPoCButtontext")}
          name={t("projects.userAccess.addSPoCButtontext")}
          variant="filled"
          size="medium"
          onClick={(): void => {
            setIsAddSPoCDialogOpen(true);
          }}
        />
        {isAddSPoCDialogOpen && (
          <AddSPoCDialog
            isAddSPoCDialogOpen={isAddSPoCDialogOpen}
            setIsAddSPoCDialogOpen={setIsAddSPoCDialogOpen}
            t={t}
            spacing={spacing}
            addNewSPoCStore={
              projectDetailsStore.userAccessStore.addNewSPoCStore
            }
            navigateTo={navigateTo}
            tokens={tokens}
            typography={typography}
            tableRef={userAccessTableRef}
          />
        )}
      </>
    );
  },
);
